import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DialogTitle } from '@mui/material';
import Sidebar from '../utils/unifiedSidebar';
import RightSidebar from '../components/Feed/RightSidebar';
import NotificationList from '../components/Notification/NotificationList';
import { useAuth } from '../context/AuthContext';
import { useMediaQuery } from '../hooks/useMediaQuery'; // Using your hook

const NotificationPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const isDesktop = useMediaQuery('(min-width: 1280px)');
  
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [filterType, setFilterType] = useState('all');

  if (!user) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Sidebar - Mounted normally as it's the main navigation */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Header - Fixed with conditional margin like your Feed setup */}
      <div className={`fixed top-0 left-0 right-0 bg-white z-40 border-b border-gray-200 ${isDesktop ? 'min-[1285px]:ml-[245px]' : 'ml-0'}`}>
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px 20px",
            backgroundColor: "#ffffff",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <button
              onClick={() => navigate(-1)}
              className="w-8 h-8 flex items-center justify-center text-black hover:bg-gray-100 rounded-full transition-colors"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="19" y1="12" x2="5" y2="12" />
                <polyline points="12 19 5 12 12 5" />
              </svg>
            </button>
            <span className="text-black font-semibold text-[18px]">Notifications</span>
          </div>
        </DialogTitle>
      </div>

      {/* ✅ Main Layout: Uses exactly the Feed.jsx container logic */}
      <div className={`pt-16 lg:pt-20 flex justify-center max-w-7xl mx-auto lg:px-6 ${isDesktop ? 'min-[1285px]:ml-[245px]' : 'ml-0'}`}>
        
        {/* Main Content: flex-1 ensures it fills space, max-w keeps it centered */}
        <div className="flex-1 min-w-0 w-full lg:max-w-5xl xl:max-w-none mt-0">
          <NotificationList filterType={filterType} />
        </div>

        {/* ✅ Right Sidebar: EXACTLY like Feed.jsx
            Only renders if isDesktop is true (min-width: 1280px).
            This unmounts the component and prevents the API call.
        */}
        {isDesktop && (
          <div className="w-80 flex-shrink-0 mt-4">
            <RightSidebar isVisible={isDesktop} />
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationPage;